import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { ThemeInt } from '../../../components/Charts/helpers/types';
import { NoDataMsg } from '../../../components/AppMessages';
import EvolutionOverTimeChart from '../../../components/Charts/GeoReporting/EvolutionOverTimeChart';


interface Props {
    queryFn: () => Record<string, any>;
    theme: ThemeInt;
    queryKey: string;
    ignoreDomainParam?: boolean;
    maxSeries?: number;
    limitToSeries?: string[];
    showPercentage?: boolean;
}


const EvolutionOverTime = withRouter((props: RouteComponentProps & Props) => {

    const { history, queryFn, theme, queryKey, ignoreDomainParam, maxSeries, limitToSeries, showPercentage } = props;

    const searchKey = React.useMemo(() => {
        const p = new URLSearchParams(history.location.search);
        p.delete("funnel");
        if (ignoreDomainParam) {
            p.delete("domain");
        }
        return p.toString();
    }, [history.location.search, ignoreDomainParam]);


    const { data, isFetching, refetch } = useQuery({
        queryKey: [queryKey, searchKey],
        queryFn: () => queryFn(),
        enabled: false,
    });

    React.useEffect(() => {
        const urlDateRange = new URLSearchParams(history.location.search).get("date_range");
        if (urlDateRange) refetch();
    }, [searchKey]);

    const filteredSeries = React.useMemo(() => {
        let series: { name: string; field: string }[] = data?.series ?? [];
        if (limitToSeries?.length) {
            series = series.filter((s) => limitToSeries.includes(s.name) || limitToSeries.includes(s.field));
        }
        if (maxSeries && series.length > maxSeries) {
            series = series.slice(0, maxSeries);
        }
        return series;
    }, [data?.series, limitToSeries, maxSeries]);

    return (
        <div className=' primary_tile_background gdr_tile'>
            <div className="tile-title">
                <div className="title_container">
                    <h3 className='summary_title'>Evolution Over Time</h3>
                </div>
                {
                    data?.data && data?.data?.length > 0 ?
                        <EvolutionOverTimeChart chartId={queryKey} data={data?.data} series={filteredSeries} height={500} theme={theme} showPercentage={showPercentage} />
                        : <div className="no_content"><NoDataMsg /></div>
                }

            </div>
        </div>
    )
});

export default EvolutionOverTime;